import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";

const WordFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="user-filters">
        <div className="field">
            <TextField
                label="Word"
                type="text"
                value={forms.sanitizeValue(data.word)}
                onChange={(event) => onChange("word", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Definition"
                type="text"
                value={forms.sanitizeValue(data.definition)}
                onChange={(event) => onChange("definition", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Sentence"
                type="text"
                value={forms.sanitizeValue(data.sentence)}
                onChange={(event) => onChange("sentence", event.target.value)}
            />
        </div>
    </div>
}

export default WordFilters;
